<ul class="dropdown-menu text-left" aria-labelledby="dropdownMenu1">
  <li><a href="#" data-value="action">
          <span class="ml-2 label label-default"><span
            class="flag-icon flag-icon-gr"></span>Greece</span> </a></li>
  <li><a href="#" data-value="another action">
    <span class="ml-2 flag-icon flag-icon-fr"></span>
    <span>France</span></a></li>
  <li><a href="#" data-value="something else here">
    <span class="ml-2 flag-icon flag-icon-us"></span>
    <span>United States</span></a>
  </li>
  <li><a href="#" data-value="separated link"><span
    class="ml-2 flag-icon flag-icon-es"></span><span> España</span></a></li>
</ul>
  <ul class="container-fluid navbar-nav js-signin-modal-trigger justify-content-end list-unstyled"
      id="navbar2SupportedContent">
    <li class="dropdown">
      <a class="bg-light btn btn-default dropdown-toggle mx-0" type="button" id="dropdownMenu1" data-toggle="dropdown"
         aria-haspopup="true" aria-expanded="true">
        <span class="flag-icon flag-icon-gr"></span></a>
      <ul class="dropdown-menu text-left" aria-labelledby="dropdownMenu1">
        <li><a href="#" data-value="action">
          <span class="ml-2 label label-default"><span
          class="flag-icon flag-icon-gr"></span>Greece</span> </a></li>
        <li><a href="#" data-value="another action">
          <span class="ml-2 flag-icon flag-icon-fr"></span>
          <span>France</span></a></li>
        <li><a href="#" data-value="something else here">
          <span class="ml-2 flag-icon flag-icon-us"></span>
          <span>United States</span></a>
        </li>
        <li><a href="#" data-value="separated link"><span
          class="ml-2 flag-icon flag-icon-es"></span><span> España</span></a></li>
      </ul>
    </li>
  </ul>
